import { useStore } from "@nanostores/react";
import { PropsWithChildren, ReactElement, useEffect } from "react";

import { closeCopilot } from "../stores/copilot.ts";
import { $modifiableGraphMeta } from "../stores/graph/metadata.ts";
import { GraphUpsertDialog } from "./GraphUpsertDialog";
import { SidebarMenu } from "./SidebarMenu";

export const RailLayout = ({ children }: PropsWithChildren): ReactElement => {
  const modifiableGraphMeta = useStore($modifiableGraphMeta);

  // Copilot is only available in workspaces (graph layout). Close it when on non-graph pages.
  useEffect(() => {
    closeCopilot();
  }, []);

  return (
    <div className="relative isolate flex h-svh w-full overflow-hidden bg-zinc-100 transition-all duration-300 ease-in-out dark:bg-zinc-950">
      <aside className="shrink-0 overflow-hidden border-r border-zinc-950/5 bg-white dark:border-white/10 dark:bg-zinc-900">
        <SidebarMenu />
      </aside>

      <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-white dark:bg-zinc-900">
        <div className="h-full min-h-0 p-4 sm:p-6 lg:bg-transparent lg:p-8">
          <div className="h-full min-h-0 w-full">{children}</div>
        </div>
      </main>

      {(modifiableGraphMeta?.type === "create" ||
        modifiableGraphMeta?.type === "copy") && <GraphUpsertDialog />}
    </div>
  );
};
